<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock
        v-if="
          !parametrage.campagnePrecoce &&
          !presences.presenceAtelier &&
          !presences.presenceEntretien
        "
        ><v-row>
          <v-col md="8" offset-md="2" xl="6" offset-xl="3">
            <v-alert type="error" elevation="2" class="text-center">
              Vous devez vous inscrire et assister à un atelier de réorientation
              avant de poursuivre votre demande de réorientation.<br />
              Vous pouvez contacter les relais Orientation pour signaler toute
              anomalie.
            </v-alert>
          </v-col>
        </v-row></BaseBlock
      >
      <BaseBlock v-else title="Mes candidatures">
        <v-row v-if="!findCandidatureConfirmee(candidatures)" align="center">
          <v-col cols="4" md="4">
            <v-btn
              :to="{ name: 'form-candidature' }"
              :disabled="!hasRemainingCandidatures"
            >
              <v-icon left>mdi-plus</v-icon>
              Nouvelle candidature
            </v-btn>
          </v-col>
          <v-col cols="8" md="8" v-if="!hasRemainingCandidatures">
            <v-alert type="warning" dense outlined class="mb-0 d-inline-flex">
              Nombre maximum de candidatures atteint
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="candidatures.length > 0">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="candidatures"
              :items-per-page="10"
              item-key="id"
              disable-sort
              class="elevation-1"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-row>
                  <v-col cols="4">
                    <router-link
                      :to="{
                        name: 'form-candidature',
                        params: { idCandidature: item.id },
                      }"
                    >
                      <v-icon
                        v-if="
                          !disableActions(item) &&
                          ((isFormationOuverte(item) && isCasModif(item)) ||
                            isRectifCandidatureAuthorized(item))
                        "
                        class="mr-2"
                        title="Éditer la candidature"
                        color="primary"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        v-else-if="!disableActions(item)"
                        class="mr-2"
                        title="Visualiser la candidature"
                        color="primary"
                        >mdi-eye</v-icon
                      ></router-link
                    >
                  </v-col>
                  <v-col cols="4">
                    <ActionConfirmation
                      v-if="item.etatDemande.id == ETAT.ACCEPTEE.code"
                      icone="mdi-account-check"
                      title="Confirmer la candidature"
                      message="Etes-vous sûr(e) de confirmer ?"
                      @ok="confirmerCandidature(item.id)"
                    ></ActionConfirmation>
                  </v-col>

                  <v-col cols="4">
                    <ActionConfirmation
                      v-if="item.etatDemande.id == ETAT.ACCEPTEE.code"
                      icone="mdi-account-arrow-right-outline"
                      colorIcone="red"
                      title="Désistement de la candidature"
                      message="Etes-vous sûr(e) de vous désister ?"
                      @ok="desistementCandidature(item.id)"
                    ></ActionConfirmation>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.etatDemande`]="{ item }">
                <span :title="getInfoEtat(item.etatDemande.id)">
                  {{ item.etatDemande.libelle }}
                  <span
                    v-if="
                      item.etatDemande.id == ETAT.ACCEPTEE.code ||
                      item.etatDemande.id == ETAT.REFUSEE.code ||
                      item.etatDemande.id == ETAT.NON_VALIDE.code ||
                      item.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
                    "
                  >
                    le {{ item.dateDecision }}</span
                  >
                  <span
                    v-if="
                      item.etatDemande.id == ETAT.CONFIRMEE.code ||
                      item.etatDemande.id == ETAT.DESISTEMENT.code ||
                      item.etatDemande.id == ETAT.ABANDON.code
                    "
                  >
                    le {{ item.dateConfirmation }}</span
                  >
                  <span v-if="item.etatDemande.id == ETAT.FINALISEE.code">
                    le {{ item.dateFinalisation }}</span
                  >
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ActionConfirmation from "@/components/ActionConfirmation";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiParametrageRepository from "@/repositories/ApiParametrageRepository";
import moment from "moment";

export default {
  name: "ListCandidaturesEtudiant",
  components: { BaseBlock, ActionConfirmation },
  mixins: [EtatDemande],

  data() {
    return {
      headers: [
        {
          text: "Formation demandée",
          align: "left",
          value: "libelleFormation",
        },
        {
          text: "Date du dépôt",
          align: "center",
          value: "dateDepot",
        },
        {
          text: "État de la demande",
          align: "center",
          value: "etatDemande",
        },
        {
          text: "Action",
          align: "center",
          value: "action",
        },
      ],
      candidatures: [],
      reorientation: {},
      presences: {},
      parametrage: {},
    };
  },
  computed: {
    isRectifCampagneAuthorized() {
      return this.aujourdhui <=
        moment(this.reorientation.dateFin, "DD/MM/YYYY").add(
          this.reorientation.nbJoursRectif,
          "days"
        )
        ? true
        : false;
    },
    aujourdhui() {
      return moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY");
    },
    hasRemainingCandidatures() {
      const candidaturesValidees = this.candidatures.filter(
        (candidature) =>
          candidature.etatDemande?.id !== this.ETAT.BROUILLON.code ||
          candidature.dateDepot != null
      );
      return candidaturesValidees.length < this.parametrage.maxCandidatures;
    },
  },

  async created() {
    this.$store.commit("setEcranChargement", true);
    await this.getPresences();
    await this.isReorientationOuverte();
    await this.getCandidatures();
    await this.getParametrage();
    this.$store.commit("setEcranChargement", false);
  },
  methods: {
    async getPresences() {
      try {
        const presences = await ApiEtudiantRepository.getPresencesEtudiant();
        this.presences = presences;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async isReorientationOuverte() {
      try {
        const reo = await ApiEtudiantRepository.isReorientationOuverte();
        this.reorientation = reo;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getCandidatures() {
      try {
        const candidatures =
          await ApiCandidatureRepository.getCandidaturesEtudiant();
        this.candidatures = candidatures;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getParametrage() {
      try {
        const parametrage = await ApiParametrageRepository.getParametrage(
          this.parametrage
        );

        this.parametrage = parametrage;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    getInfoEtat(codeEtat) {
      switch (codeEtat) {
        case this.ETAT.BROUILLON.code:
          return "La demande n’est pas validée, je peux la modifier";
        case this.ETAT.VALIDATION_SUAIO.code:
          return "Vous avez validé votre demande, le SUAIO vérifie que vous avez bénéficié d’un accompagnement";
        case this.ETAT.TRAITEMENT_PEDAGOGIQUE.code:
          return "Votre demande a été validée par le SUAIO et transmise à l’enseignant pour examen";
        case this.ETAT.ACCEPTEE.code:
          return "Votre demande de réorientation est acceptée. Une notification vous sera adressée pour vous indiquer la procédure à suivre pour le changement de votre d’inscription";
        case this.ETAT.REFUSEE.code:
          return "Votre demande de réorientation est refusée. Le motif du refus vous sera transmis par notification";
        case this.ETAT.NON_VALIDE.code:
          return "Non autorisé à se réorienter ou demande incomplète";
      }
      return "";
    },
    isCasModif(candidature) {
      return candidature.etatDemande.id === this.ETAT.BROUILLON.code ||
        candidature.etatDemande.id === this.ETAT.RECTIFICATION.code
        ? true
        : false;
    },
    isCasRectif(candidature) {
      return this.isCasModif(candidature) &&
        candidature.dateDepot &&
        candidature.dateDepot.length > 0
        ? true
        : false;
    },
    isFormationOuverte(candidature) {
      return candidature.dateFermetureFormation
        ? this.aujourdhui <=
            moment(candidature.dateFermetureFormation, "DD/MM/YYYY")
        : this.aujourdhui <= moment(this.reorientation.dateFin, "DD/MM/YYYY");
    },
    isRectifCandidatureAuthorized(candidature) {
      if (!this.isCasRectif(candidature)) {
        return false;
      }
      if (!candidature.dateFermetureFormation) {
        // pas de date de fin spécifique à la formation => on se base sur date fin réo
        return this.isRectifCampagneAuthorized;
      }
      // date fin spécifique
      let dateFermetureFormation = moment(
        candidature.dateFermetureFormation,
        "DD/MM/YYYY"
      );
      if (
        this.aujourdhui <=
        dateFermetureFormation.add(this.reorientation.nbJoursRectif, "days")
      ) {
        return true;
      } else {
        return false;
      }
    },
    disableActions(item) {
      return (
        item.etatDemande.id === this.ETAT.BROUILLON.code &&
        item.dateDepot == null &&
        !this.hasRemainingCandidatures
      );
    },
    async confirmerCandidature(idCandidature) {
      try {
        const candidature = await ApiCandidatureRepository.confirmerCandidature(
          idCandidature
        );
        this.getCandidatures();
        this.$toast.success(
          "Votre demande d'inscription à la formation " +
            candidature.libelleFormation +
            " est enregistrée."
        );
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async desistementCandidature(idCandidature) {
      try {
        const candidature =
          await ApiCandidatureRepository.desistementCandidature(idCandidature);
        this.getCandidatures();
        this.$toast.success(
          "Votre désistement à la formation " +
            candidature.libelleFormation +
            " est enregistrée."
        );
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    findCandidatureConfirmee(candidatures) {
      return candidatures.find(
        (candidature) =>
          candidature.etatDemande.id === this.ETAT.CONFIRMEE.code ||
          candidature.etatDemande.id === this.ETAT.FINALISEE.code
      );
    },
  },
};
</script>
